// src/pages/SearchPage.jsx
import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../Homepage/Navbar";
import Feed from "../Homepage/feed"; // your feed component (from feed.js)
import "./search.css";
import { FaBookmark, FaChevronDown } from "react-icons/fa";
import SearchLoadingPeople from "../Loading/search-loading-people";
import MessageModal from "../messgaes/MessageModal";
import LostFound from "../LostFound/LostFound";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function SearchPage() {
  const server = process.env.REACT_APP_SERVER;
  const loggedInUserId = JSON.parse(localStorage.getItem("user"))?.id;
  const [selectedPeer, setSelectedPeer] = useState(null);

  const queryParams = useQuery();
  const navigate = useNavigate();
  const q = queryParams.get("q") || "";

  const [type, setType] = useState(() => {
    return (queryParams.get("type") || "students").toLowerCase();
  });

  // students/professors state
  const [users, setUsers] = useState([]);
  const [usersPage, setUsersPage] = useState(1);
  const [usersHasMore, setUsersHasMore] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(false);

  // reset when q or type changes
  useEffect(() => {
    setUsers([]);
    setUsersPage(1);
    setUsersHasMore(true);
    if (type !== "posts") fetchUsers(1, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, type]);

  // fetch users (students/professors)
  const fetchUsers = useCallback(
    async (page = 1, replace = false) => {
      if (!q || q.trim() === "") {
        setUsers([]);
        setUsersHasMore(false);
        return;
      }
      setLoadingUsers(true);
      try {
        const token = localStorage.getItem("token");
const endpoint =
  type === "students"
    ? `${server}/api/search/students`
    : type === "professors"
    ? `${server}/api/search/professors`
    : `${server}/api/search/clubs`;
        const res = await axios.get(endpoint, {
          headers: { Authorization: `Bearer ${token}` },
          params: { q: q, page },
        });
        const newResults = res.data.results || [];
        setUsers((prev) => (replace ? newResults : [...prev, ...newResults]));
        setUsersHasMore(newResults.length === 10);
        setUsersPage(page + 1);
      } catch (err) {
        console.error("Search users failed", err);
        setUsersHasMore(false);
      } finally {
        setLoadingUsers(false);
      }
    },
    [q, type]
  );

  const switchType = (newType) => {
    setType(newType);
    const params = new URLSearchParams(window.location.search);
    params.set("type", newType);
    navigate(`/search?${params.toString()}`, { replace: true });
  };

  return (
    <>
      {selectedPeer && (
        <MessageModal
          isOpen={!!selectedPeer}
          onClose={() => setSelectedPeer(null)}
          peer={selectedPeer}
        />
      )}
     

      <div className="search-cont-2">
        <div className="search-page">
          <p className="search-heading">
            Search results for <span>"{q}"</span>
          </p>

          <div className="search-tabs">
            <button
              onClick={() => switchType("students")}
              className={`switch-btn ${type === "students" ? "active" : ""}`}
            >
              Students
            </button>
            <button
              onClick={() => switchType("professors")}
              className={`switch-btn  ${type === "professors" ? "active" : ""}`}
            >
              Professors
            </button>
            <button
              onClick={() => switchType("clubs")}
              className={`switch-btn  ${type === "clubs" ? "active" : ""}`}
            >
              Clubs
            </button>
            <button
              onClick={() => switchType("posts")}
              className={`switch-btn  ${type === "posts" ? "active" : ""}`}
            >
              Posts
            </button>
          </div>

          <div className="search-results">
            {type === "posts" ? (
              <Feed
                key={`posts-${q}`}
                fetchUrlBuilder={(page) => ({
                  url: `${server}/api/search/posts`,
                  params: { q: q, page },
                })}
                onNavigateProfile={(userId) => navigate(`/profile/${userId}`)}
                onTagNavigate={(tag) => {
                  navigate(`/search?q=${encodeURIComponent(tag)}&type=posts`);
                }}
                autoFetchOnMount={true}
              />
            ) : (
              <>
                <div className="search-res-people">
                  {users.map((u) => (
                    <div key={u.id} className="result-card">
                      {u.avatar_url ? (
                        <img
                          src={u.avatar_url}
                          className="search-img"
                          alt="profile"
                        />
                      ) : (
                        <div className="avatar-fallback">
                          {`${u?.first_name?.[0] || ""}${
                            u?.last_name?.[0] || ""
                          }`.toUpperCase()}
                        </div>
                      )}
                      <div className="result-card-body">
                        <div
                          style={{ fontWeight: 700, cursor: "pointer" }}
                          onClick={() => {
                            if (u.id !== loggedInUserId) {
                              navigate(`/profile/${u.id}`);
                            }
                          }}
                        >
                          {u.first_name} {u.last_name}
                        </div>
                        <div style={{ color: "#555" }}>
                          {type === "students"
  ? u.course
  : type === "professors"
  ? u.specialization
  : ""}
                        </div>
                        <div style={{ color: "#888", fontSize: 13 }}>
                          {u.university}
                        </div>
                      </div>
                      <button
                        onClick={() =>
                          setSelectedPeer({ ...u, profile: u.avatar_url })
                        }
                        className="form-button"
                        style={{ width: "fit-content" }}
                      >
                        Message
                      </button>
                    </div>
                  ))}
                  {users.length === 0 && !loadingUsers && (
                    <div style={{ color: "#777" }}>No results found.</div>
                  )}
                </div>

                {usersHasMore && (
                  <>
                    {loadingUsers && <SearchLoadingPeople />}

                    <div style={{ textAlign: "center", marginTop: 12 }}>
                      <button
                        onClick={() => fetchUsers(usersPage, false)}
                        className="show-more-btn"
                      >
                        {loadingUsers ? "Loading..." : "Show More"}
                      </button>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
        <div className="hider-small">
          <LostFound />
        </div>
      </div>
    </>
  );
}
